var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-product-link',{staticClass:"o-button",attrs:{"product":_vm.product}},[_c('i',{staticClass:"o-icon o-button__icon",class:_vm.iconClass}),(_vm.showLabel)?_c('span',{staticClass:"o-typography__label o-button__label"},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }